import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createDataExtensionSchemaRequest = {
    dataExtensionSchema: '_dataExtensionSchema',
};
var _createDataExtensionSchemaResponse = {
    dataExtensionSchema: '_dataExtensionSchema',
};
var _dataExtensionSchema = {
    updatedDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
};
var _deleteByWhiteListedMetaSiteRequest = {};
var _deleteByWhiteListedMetaSiteResponse = {};
var _listDataExtensionSchemasRequest = {};
var _listDataExtensionSchemasResponse = {
    dataExtensionSchemas: '_dataExtensionSchema',
};
var _updateDataExtensionSchemaRequest = {
    dataExtensionSchema: '_dataExtensionSchema',
};
var _updateDataExtensionSchemaResponse = {
    dataExtensionSchema: '_dataExtensionSchema',
};
function resolveWixInfraDataextensionsV1DataExtensionSchemaServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/schema-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/schema-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/schema-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/schema-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a user-defined data extension schema. */
export function createDataExtensionSchema(payload) {
    var _a = serializer(_createDataExtensionSchemaRequest, { _dataExtensionSchema: _dataExtensionSchema }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDataExtensionSchemaResponse, {
        _dataExtensionSchema: _dataExtensionSchema,
    }).fromJSON;
    function __createDataExtensionSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_extensions.v1.data_extension_schema',
            method: 'POST',
            methodFqn: 'wix.infra.dataextensions.v1.DataExtensionSchemaService.CreateDataExtensionSchema',
            url: resolveWixInfraDataextensionsV1DataExtensionSchemaServiceUrl({
                protoPath: '/v1/schemas',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDataExtensionSchema.fromReq = fromReq;
    __createDataExtensionSchema.__isAmbassador = true;
    return __createDataExtensionSchema;
}
/** Updates a user-defined data extension schema, overriding the existing data. */
export function updateDataExtensionSchema(payload) {
    var _a = serializer(_updateDataExtensionSchemaRequest, { _dataExtensionSchema: _dataExtensionSchema }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDataExtensionSchemaResponse, {
        _dataExtensionSchema: _dataExtensionSchema,
    }).fromJSON;
    function __updateDataExtensionSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_extensions.v1.data_extension_schema',
            method: 'PUT',
            methodFqn: 'wix.infra.dataextensions.v1.DataExtensionSchemaService.UpdateDataExtensionSchema',
            url: resolveWixInfraDataextensionsV1DataExtensionSchemaServiceUrl({
                protoPath: '/v1/schemas',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDataExtensionSchema.fromReq = fromReq;
    __updateDataExtensionSchema.__isAmbassador = true;
    return __updateDataExtensionSchema;
}
/** Retrieves a list of global and user-defined data extension schemas for a given FQDN. */
export function listDataExtensionSchemas(payload) {
    var _a = serializer(_listDataExtensionSchemasRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDataExtensionSchemasResponse, {
        _dataExtensionSchema: _dataExtensionSchema,
    }).fromJSON;
    function __listDataExtensionSchemas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_extensions.v1.data_extension_schema',
            method: 'GET',
            methodFqn: 'wix.infra.dataextensions.v1.DataExtensionSchemaService.ListDataExtensionSchemas',
            url: resolveWixInfraDataextensionsV1DataExtensionSchemaServiceUrl({
                protoPath: '/v1/schemas',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDataExtensionSchemas.fromReq = fromReq;
    __listDataExtensionSchemas.__isAmbassador = true;
    return __listDataExtensionSchemas;
}
/** Deletes schemas of whitelisted metasite ids */
export function deleteByWhiteListedMetaSite(payload) {
    var _a = serializer(_deleteByWhiteListedMetaSiteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteByWhiteListedMetaSiteResponse, {}).fromJSON;
    function __deleteByWhiteListedMetaSite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_extensions.v1.data_extension_schema',
            method: 'POST',
            methodFqn: 'wix.infra.dataextensions.v1.DataExtensionSchemaService.DeleteByWhiteListedMetaSite',
            url: resolveWixInfraDataextensionsV1DataExtensionSchemaServiceUrl({
                protoPath: '/v1/schemas/delete-by-white-listed-meta-site',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteByWhiteListedMetaSite.fromReq = fromReq;
    __deleteByWhiteListedMetaSite.__isAmbassador = true;
    return __deleteByWhiteListedMetaSite;
}
//# sourceMappingURL=http.impl.js.map